<template lang="pug">
.ui-page
  .ui-page__header(v-if="showHeader")
    .ui-page__title
      slot(name="title") {{ title }}
    .ui-page__actions(v-if="$slots.actions")
      slot(name="actions")
  .ui-page__body
    slot
</template>

<script>
export default {
  props: {
    title: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    showHeader() {
      return this.$slots.title || this.title;
    },
  },
};
</script>

<style lang="scss">
.ui-page {
  padding-top: 2rem;
  padding-bottom: 2rem;

  &__header {
    padding-left: 2rem;
    padding-right: 2rem;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
  }

  &__title {
    flex-grow: 1;
    flex-shrink: 0;
    font-size: 1.75rem;
    font-weight: 600;
  }

  &__actions {
    flex-shrink: 0;
  }
}
</style>
